export default {
      id: "icon-app_links-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-app_links",
      toString: function () {
        return this.url;
      }
    }